export default __webpack_public_path__ + "static/media/about-img-4.cfa9f697.png";